// extracted by mini-css-extract-plugin
module.exports = {"promo-code__title":"promo-code_promo-code__title__RpNjA","promo-code__content":"promo-code_promo-code__content__SIgun","promo-code__input":"promo-code_promo-code__input__Sj1Rf"};